<template>
    <div class="sitePage">
        <!--乡镇站点-->
        <div class="nav">
            <div class="item timeC">
                <!--时间选择-->
                <el-date-picker
                        class="itemValue"
                        size="mini"
                        v-model="queryParam.times"
                        type="datetimerange"
                        @change="queryParamChange"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div class="item">
                <el-select class="itemValue" v-model="queryParam.source" placeholder="请选择公司" @change="sourceChange"
                           size="mini">
                    <el-option label="蓝盾" :value="1"></el-option>
                    <el-option label="精怡" :value="2"></el-option>
                </el-select>
            </div>
            <div class="item">
                <el-select class="itemValue" v-model="queryParam.stationCode" @change="queryParamChange"
                           placeholder="请选择站点" size="mini">
                    <el-option v-for="item in siteList" :label="item.stationName" :value="item.stationCode"
                               :key="item.id"></el-option>
                </el-select>
            </div>
            <div class="Range">
                <div class="item time"
                     v-for="(item,index) in timeList"
                     :class="item.value===queryParam.dataType ? 'active' :''"
                     @click="navTimeChange(item)"
                     :key="index">
                    {{item.label}}
                </div>
            </div>
            <!--  选择实况值  出现选择站点功能-->

            <div class="center"></div>
            <a-button class="btn" type="primary" size="small" @click="getSiteList">查询</a-button>
            <a-button class="btn" type="primary" size="small" @click="audit">保存</a-button>
            <!--            <a-button class="btn" type="primary" size="small" @click="exportExcel">导出</a-button>-->

        </div>
        <div class="content siteTable">
            <div class="aqibox noFloat">
                <div class="table_title">
                    <div class="auditTips">
                        <div class="tipsItem tipsBlue"> 倒挂</div>
                        <div class="tipsItem tipsMin"> 小于阈值</div>
                        <div class="tipsItem tipsMax"> 大于阈值</div>
                    </div>
                    <div class="titletab">
                        <table class="table table-bordered table-hover info tabletitle" style="font-size:14px;"
                               border="2">
                            <tbody>
                            <tr>
                                <td rowspan="1" style="width:6%;">
                                    <el-checkbox @change="allChenk">全选</el-checkbox>
                                </td>
                                <td rowspan="1" style="width:10.5%;">
                                    <span>
                                        时间
                                    </span>
                                </td>
                                <td rowspan="1" style="width:10.5%;">
                                    <span>
                                        站点
                                    </span>
                                </td>
                                <td colspan="1" style="width:9.5%;">PM<sub>2.5</sub></td>
                                <td colspan="1" style="width:9.5%;">PM<sub>10</sub></td>
                                <td colspan="1" style="width:9.5%;">SO<sub>2</sub></td>
                                <td colspan="1" style="width:9.5%;">NO<sub>2</sub></td>
                                <td colspan="1" style="width:9.5%;">NO</td>
                                <td colspan="1" style="width:9.5%;">CO</td>
                                <td colspan="1" style="width:9.5%;">O<sub>3</sub></td>
                                <td colspan="1" style="width:16%;">o38h</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="table_scrollar mCustomScrollbar _mCS_1 mCS-autoHide" style="width: 100%; height: 500px;">
                    <div id="mCSB_1" class="mCustomScrollBox tabScrollbar mCS-light mCSB_vertical mCSB_inside"
                         style="max-height: none;" tabindex="0">
                        <div id="mCSB_1_container" class="mCSB_container" style="position:relative; top:0; left:0;"
                             dir="ltr">
                            <div id="showTable" class="table_center">
                                <el-checkbox-group v-model="checkList">
                                    <table class="table table-bordered table-hover info" style="font-size:12px;"
                                           border="2"
                                           v-if="data&&data.length"
                                           v-loading="loading"
                                    >
                                        <tbody>

                                        <template v-for="(item,index) in data">
                                            <el-tooltip v-if="item.resultType===0" class="item" effect="dark"
                                                        :content="'数据已被审核,审核原因:'+item.resultContent+','" placement="top" :key="index">
                                                <tr :bgcolor="index%2 ===0? '' :'#dce9ee'"
                                                    :key="index">
                                                    <td align="center" valign="middle" style="width:6%;">
                                                        <el-checkbox :label="item.id"><span></span></el-checkbox>
                                                    </td>
                                                    <td align="center" valign="middle" style="width:10.5%;">
                                                        {{item.timePoint ||
                                                        '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:10.5%;">
                                                        {{item.stationName || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle(item.upsideDown,item.isPm25)">
                                                        {{item.pm25 || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isPm10)">
                                                        {{item.pm10 || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isSo2)">{{item.so2 || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isNo2)">{{item.no2 || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isNo)">{{item.no || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isCo)">{{item.co || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:9.5%;"
                                                        :style="diyConTitleStyle('',item.isO3)">{{item.o3 || '-'}}
                                                    </td>
                                                    <td align="center" valign="middle" style="width:16%;"
                                                        :style="diyConTitleStyle('',item.isO38h)">{{item.o38h || '-'}}
                                                    </td>
                                                </tr>
                                            </el-tooltip>
                                            <tr v-else :bgcolor="index%2 ===0? '' :'#dce9ee'"
                                                :key="index">
                                                <td align="center" valign="middle" style="width:6%;">
                                                    <el-checkbox :label="item.id"><span></span></el-checkbox>
                                                </td>
                                                <td align="center" valign="middle" style="width:10.5%;">{{item.timePoint
                                                    ||
                                                    '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:10.5%;">
                                                    {{item.stationName || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle(item.upsideDown,item.isPm25)">
                                                    {{item.pm25 === 0 ? 0 : item.pm25 || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isPm10)">
                                                    {{item.pm10 === 0 ? 0 : item.pm10 || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isSo2)">{{item.so2 === 0 ? 0 : item.so2 || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isNo2)">{{item.no2 === 0 ? 0 : item.no2 || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isNo)">{{item.no === 0 ? 0 : item.no || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isCo)">{{item.co=== 0 ? 0 : item.co || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:9.5%;"
                                                    :style="diyConTitleStyle('',item.isO3)">{{item.o3=== 0 ? 0 : item.o3 || '暂无'}}
                                                </td>
                                                <td align="center" valign="middle" style="width:16%;"
                                                    :style="diyConTitleStyle('',item.isO38h)">{{item.o38h === 0 ? 0 : item.o38h || '暂无'}}
                                                </td>
                                            </tr>
                                        </template>
                                        </tbody>
                                    </table>
                                    <div v-else style="text-align: center;margin: 20px 0">暂无数据</div>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination" style="text-align: right; width: 100%">
                    <el-pagination
                            size="mini"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page.sync="queryParam.page"
                            :page-size="queryParam.pageSize"
                            layout="prev, pager, next, jumper"
                            background
                            :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!--        <div class="saveBtn" @click="audit">-->
        <!--            保存-->
        <!--        </div>-->


    </div>
</template>

<script>
    import url from "../utils/UrlApi"

    Date.prototype.nowDateFormat = function () { //author:
        var d = new Date()
        var year = d.getFullYear()
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
        var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
        var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
        var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
    };
    Date.prototype.nowDayDateFormat = function () { //author:
        var d = new Date()
        var year = d.getFullYear()
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : '' + (d.getMonth() + 1)
        var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
        // var hour = d.getHours()  < 10 ? '0' + d.getHours() : '' + d.getHours()
        // var minutes = d.getMinutes()  < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
        // var seconds = d.getSeconds()  < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
        // return hour + ':' + minutes + ':' + seconds
        return year + '-' + month + '-' + day + ' ' + '00:00:00'
    };


    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "DataAudit",
        data() {
            return {
                data: [],
                loading: true,
                queryParam: {
                    // timeRange: 1,   // 是否是任意范围
                    page: 1,
                    pageSize: 30,
                    dataType: 1,
                    times: [new Date().nowDayDateFormat(), new Date().nowDateFormat()],
                    // times: [],
                    startTime: '', //起始时间
                    endTime: '', // 截止时间
                    stationCode: '',
                    source: ''
                },
                pagination: {
                    total: 0,
                    pageSize: 30,//每页中显示10条数据
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
                    showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
                },
                checkList: [],
                timeList: [
                    {label: '小时', value: 1},
                    {label: '日均', value: 2},
                ],
                props: {
                    multiple: true,
                    // checkStrictly: true,
                    // emitPath: true,

                    label: 'stationName',
                    value: 'stationCode'
                },
                siteList: [],
            }
        },
        computed: {},
        created() {
            this.getSiteList()
            this.getStationList()
        },
        methods: {
            getSiteList() {
                this.loading = true
                let data = JSON.parse(JSON.stringify(this.queryParam))
                if (data.times && data.times.length) {
                    data.startTime = data.times[0]
                    data.endTime = data.times[1]
                }
                data.times = ""
                this.$http.get(url.suzhouData, {params: data}).then(res => {
                    // console.log(res)
                    if (res.data.code === '200') {
                        this.loading = false
                        this.data = res.data.data.list
                        this.pagination.total = res.data.data.totalCount
                        // console.log(res)

                    } else {
                        this.$message.error(res.data.message)
                    }

                })
            },
            allChenk(value) {
                console.log(value)

                if (value) {
                    let list = []
                    this.data.forEach((res) => {
                        list.push(res.id)
                    })
                    this.checkList = list
                } else {
                    this.checkList = []
                }
            },

            audit() {
                this.$prompt('请输入审核原因', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                    // inputErrorMessage: '邮箱格式不正确'
                }).then(({value}) => {
                    let data = {
                        list: this.checkList,
                        content: value
                    }
                    this.$http.post(url.suzhouDataAudit, data).then(res => {

                        if (res.data.code === '200') {
                            this.$message.success('审核成功')
                            this.checkList = []
                            this.getSiteList()
                        } else {
                            this.$message.error(res.data.message)
                        }

                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },

            //  获取站点列表
            getStationList(source) {
                let data = {
                    source: source
                }
                this.$http.get(url.thresholdStationsList, {params: data}).then(res => {
                    if (res.data.code === "200") {
                        this.siteList = res.data.data
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },

            // 分页切换
            handleTableChange(pagination, filters, sorter) {
                // console.log(pagination,filters,sorter)

                this.queryParam.page = pagination.current
                this.queryParam.pageSize = pagination.pageSize

                this.getSiteList()
            },

            queryParamChange() {
                this.queryParam.page = 1
                this.getSiteList()
            },
            sourceChange(source) {
                this.queryParam.stationCode = ''
                this.getStationList(source)
                this.getSiteList()
            },
            //  时间切换
            onChange(params) {
                this.queryParam.startTime = params[0]
                this.queryParam.endTime = params[1]
                // console.log('params');
            },

            navTimeChange(item) {
                this.queryParam.dataType = item.value
                this.getSiteList()
            },
            navTimeRangeChange(item) {
                this.queryParam.timeRange = item.value
                this.getSiteList()
            },

            iChange(orderName, order) {
                this.queryParam.orderName = orderName
                this.queryParam.order = order
                this.getSiteList()
            },
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
                this.queryParam.pageSize = val
                this.getSiteList()
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.queryParam.page = val
                this.getSiteList()
            },


            //     判断颜色
            colorjudge(value) {


                if (value <= 50) {
                    return 'green'
                }
                if (value <= 100) {
                    return 'yellow'
                }
                if (value <= 150) {
                    return 'orange'
                }
                if (value <= 200) {
                    return 'red'
                }
                if (value <= 300) {
                    return 'purple'
                }
                if (value > 300) {
                    return 'saddlebrown'
                }


            },

            diyConTitleStyle: function (upsideDown, is) {
                var dt = {
                    "color": '',
                    "background-color": ''
                }

                if (is === 1) {
                    dt["background-color"] = 'green'
                    dt['color'] = '#fff'
                }

                if (is === 2) {
                    dt["background-color"] = 'red'
                    dt['color'] = '#fff'
                }

                if (upsideDown === 1) {
                    dt["background-color"] = 'blue'
                    dt['color'] = '#fff'
                }
                //过滤掉即删除掉空值的参数和数值
                for (var i in dt) {
                    dt[i] == "" ? delete (dt[i]) : 1
                }
                return dt
            }
        },
    }
</script>

<style scoped lang="less">

    .saveBtn {
        margin: 10px auto;
        width: 200px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        border-radius: 10px;
        background-color: #40a9ff;
        color: #fff;
        cursor: pointer;
    }

    .aqibox {
        margin: 6px 30px;
    }

    .sitePage {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    .nav {
        display: flex;
        align-items: center;
        padding: 10px 30px;
        background-color: #fff;
        /*margin: 10px 0;*/

        .center {
            flex: 1;
        }

        .tabname {
            margin-right: 10px;
        }

        .item {
            cursor: pointer;
            margin-right: 8px;

            .itemValue {
                width: 100%;
            }
        }

        .timeC {
        }

        .time {
            border: 1px solid #ddd;
            padding: 3px 6px;
            border-radius: 4px;
        }

        .active {
            background-color: #bfd9e1;
        }

        .btn {
            margin: 0 5px;
        }

        .Range {
            display: flex;
            margin-left: 10px;
        }
    }

    .siteTable {
        flex: 1;
        box-sizing: border-box;
        overflow: auto;

        .tag {
            color: #fff;
            width: 100%;
            height: 100%;
            text-align: center;
            padding: 4px 0;
            border-radius: 4px;
            font-size: 10px;
        }

        .tag1 {
            background-color: green;
        }

        .tag2 {
            background-color: yellow;
            color: #000;
        }

        .tag3 {
            background-color: orange;
        }

        .tag4 {
            background-color: red;
        }

        .tag5 {
            background-color: purple;
        }

        .tag6 {
            background-color: saddlebrown;
        }

        .tag7 {
            background-color: grey;
        }
    }

    .tabletitle {
        tr {
            td {
                /*display: flex;*/

                span {
                    position: relative;
                    width: 100%;
                    left: 0;

                    i {
                        position: absolute;
                        left: 0;
                    }

                    .active {
                        color: #1daaf1;
                    }
                }
            }
        }
    }


    .auditTips {
        display: flex;
        margin-bottom: 10px;

        .tipsItem {
            position: relative;
            padding-left: 16px;
            margin: 0 10px;
        }

        .tipsBlue:after {
            content: "";
            position: absolute;
            width: 10px;
            height: 10px;
            left: 0;
            top: 50%;
            margin-top: -5px;
            background-color: blue;

        }

        .tipsMin:after {
            content: "";
            position: absolute;
            width: 10px;
            height: 10px;
            left: 0;
            top: 50%;
            margin-top: -5px;
            background-color: green;
        }

        .tipsMax:after {
            content: "";
            position: absolute;
            width: 10px;
            height: 10px;
            left: 0;
            top: 50%;
            margin-top: -5px;
            background-color: red;
        }
    }
</style>

<style scoped>
    @import "../assets/siteCss/bootstrap-responsive.min.css";
    @import "../assets/siteCss/bootstrap.min.css";
    @import "../assets/siteCss/daterangepicker-bs3.css";
    @import "../assets/siteCss/font-awesome.min.css";
    @import "../assets/siteCss/iconfont.css";
    @import "../assets/siteCss/innerStyle.css";
    @import "../assets/siteCss/jquery.mCustomScrollbar.min.css";
    @import "../assets/siteCss/multiple-select.css";
    @import "../assets/siteCss/normalize.css";
    @import "../assets/siteCss/page.css";
    @import "../assets/siteCss/table.css";

</style>